import * as React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import { VersionNumber } from '../../version';
import './Footer.css';

export default class HeaderLoggedOut extends React.PureComponent {
    public render() {
        return (
            <div className="footer">
                <Container>
                    <Row>
                        <Col className="text-center">
                            {TR.footer_copyright} | v 1.0-{VersionNumber}
                            <br />
                            <a href="https://kukundo.de/impressum/" target="_blank">
                                {TR.footer_imprint}
                            </a>{' '}
                            -
                            <a href="https://kukundo.de/agb-kursanbieter/" target="_blank">
                                {TR.footer_agb}
                            </a>{' '}
                            -
                            <a href="https://kukundo.de/datenschutzerklaerung/" target="_blank">
                                {TR.footer_data_privacy}
                            </a>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/footer/Footer.tsx